var render = function render(){var _vm=this,_c=_vm._self._c;return _c(_vm.component,{tag:"component",staticClass:"address-link ui-looong",class:{ clickable: !_vm.isDisabled, muted: !_vm.address, 'full-name': _vm.hasDisplayName },attrs:{"to":_vm.routerParams,"data-loopa":_vm.name.substr(0, 40),"data-poopa":_vm.name.substr(40)},nativeOn:{"click":function($event){$event.stopPropagation();}}})
}
var staticRenderFns = []

export { render, staticRenderFns }